import { Client } from '@petfinder/petfinder-js';

const client = new Client({
  apiKey: 'YOk42ZUgyaMxHIYyONF6YALnGfeKmmLv4v08lyI186PIJNrs0K',
  secret: 'SqnR3tYHs7WczX55jSaIhmaTVXIDn27d7k0HC5FJ',
});

export default client;